import { useEffect } from 'react';
import { useScheduler } from '@/contexts/SchedulerContext';

const CTA_PATTERNS = /^(schedule|book|get started|request.*audit|connect.*team|priority access|revenue integrity audit)$/i;

/**
 * Global CTA handler that intercepts clicks on marketing CTA buttons
 * and opens the scheduler modal instead of their default behavior.
 */
export function GlobalCTAHandler() {
  const { openScheduler } = useScheduler();

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const el = target.closest<HTMLElement>('[data-cta="schedule"], a[href="/book"]');

      if (el) {
        e.preventDefault();
        e.stopPropagation();
        const slug = el.getAttribute('data-meeting-type') || undefined;
        openScheduler(slug);
        return;
      }

      // Check button/anchor text content
      const clickable = target.closest<HTMLElement>('button, a');
      if (clickable) {
        const text = clickable.textContent?.trim() || '';
        const href = clickable.getAttribute('href') || '';
        
        // Don't intercept navigation links, only CTA-style buttons
        if (href && href !== '#' && href !== '/book' && !href.startsWith('/#')) return;
        
        if (CTA_PATTERNS.test(text)) {
          e.preventDefault();
          e.stopPropagation();
          openScheduler();
        }
      }
    };

    // Use capture phase to intercept before React handlers
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, [openScheduler]);

  return null;
}
